import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { serviceType } from '../../types';

type initialStateType = {
    services: Array<serviceType>;
    is_loading_services: boolean;
    is_adding_service: boolean;
    is_editing_service: boolean;
    is_deleting_service: boolean;
};

const initialState: initialStateType = {
    services: [],
    is_loading_services: false,
    is_adding_service: false,
    is_editing_service: false,
    is_deleting_service: false,
};

export const servicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        setServices: (state, action: PayloadAction<Array<serviceType>>) => {
            return {
                ...state,
                services: action.payload,
            };
        },
        onAddingService: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_adding_service: action.payload,
            };
        },
        onLoadingServices: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_services: action.payload,
            };
        },
        onEditingService: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_editing_service: action.payload,
            };
        },
        onDeletingService: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_deleting_service: action.payload,
            };
        },
    },
});

export const { setServices, onAddingService, onLoadingServices, onEditingService, onDeletingService } = servicesSlice.actions;

export default servicesSlice.reducer;